module.exports = __webpack_public_path__ + "img/background-register.22d42a2c.png";